export default function orderStatus(status) {
  // Remap statuses to a smaller set that is presented to users
  return {
    [WAITING_FOR_REVIEW]: 'review',
    [ORDER_CREATED]: 'open',
    [READY_FOR_PRODUCTION]: 'open',
    [PENDING_PRODUCTION]: 'open',
    [IN_PRODUCTION]: 'open',
    [PARTIALLY_SHIPPED]: 'open',
    [SHIPPED]: 'shipped',
    [DELIVERED]: 'shipped',
    [CANCELLED]: 'cancelled'
  }[status] || status;
}

export function shortStatus(status) {
  // Return shorter labels of statuses for admin purposes.
  // Every status results in different value.
  return {
    [ORDER_CREATED]: 'Created',
    [WAITING_FOR_REVIEW]: 'Review',
    [READY_FOR_PRODUCTION]: 'Ready',
    [PENDING_PRODUCTION]: 'Pending',
  }[status] || status;
}

export const ORDER_CREATED = 'Order Created';
export const WAITING_FOR_REVIEW = 'Waiting for Review';
export const READY_FOR_PRODUCTION = 'Ready for production';
export const PENDING_PRODUCTION = 'Pending production';
export const IN_PRODUCTION = 'In Production';
export const PARTIALLY_SHIPPED = 'Partially Shipped';
export const SHIPPED = 'Shipped';
export const DELIVERED = 'Delivered';
export const CANCELLED = 'Cancelled';

export const ALL_STATUSES = [
  ORDER_CREATED,
  WAITING_FOR_REVIEW,
  READY_FOR_PRODUCTION,
  PENDING_PRODUCTION,
  IN_PRODUCTION,
  PARTIALLY_SHIPPED,
  SHIPPED,
  DELIVERED,
  CANCELLED,
];

// Main subset that staff need to care about
export const MAIN_STATUSES = [
  READY_FOR_PRODUCTION, IN_PRODUCTION, SHIPPED
];

export function resendable(status) {
  // Statuses for which orders can be resent.
  return ALL_STATUSES.indexOf(status) > ALL_STATUSES.indexOf(READY_FOR_PRODUCTION)
}

export function unsent(status) {
  // Statuses for which orders haven't been sent.
  return ALL_STATUSES.indexOf(status) < ALL_STATUSES.indexOf(PENDING_PRODUCTION)
}




// WEBPACK FOOTER //
// ./src/lib/orderStatus.js